<ion-header>
    <ion-toolbar #headerToolbar style="--background:var(--myDisabledEnabledColor)">
        <ion-buttons slot="start">
            <ion-back-button [disabled]=vb.disabled data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Route Wizard</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<!--
Note 1: Only show the ticket address if it's not the dealership address.
        Assume the driver knows the dealership address.
Note 2: items outside the ion-reorder-group will not have the movable hamburger icon.
        That is why the starting ticket and the ending ticket are outside the ion-reorder-group.
-->

<ion-content>
    <ion-list-header color="secondary" data-test="listHeader">
        Route Ordering - (Step 4 of 8)
    </ion-list-header>

    <ion-list class="ion-text-wrap" ion-no-padding>
        <ion-item class="ion-no-padding">
            <ion-grid>
                <!--
                    1,10,1 = first column is too narrow 
                    3,8,1 = first column is too wide.  
                -->
                <ion-row class="ion-align-items-center">
                    <ion-col class="imageCol ion-float-left" size="2" size-md="1" style="max-width: 80px !important">
                        <img class="startEndImage" src="assets/images/startNS.png" />
                    </ion-col>
                    <ion-col class="legDescCol ion-float-right" size="10" size-md="11">
                        <span class="line1">Start: {{vm.startingPoint.location.locationName}}</span><br />
                        <span class="line2">{{vm.startingPoint.location.address.fullAddress}}</span><br />
                    </ion-col>
                    <!-- <ion-col class="letterCol" size="1" size-md="1" ion-float-right>
                        <span class="line1"> </span><br />
                    </ion-col> -->
                </ion-row>
            </ion-grid>
        </ion-item>
    </ion-list>

    <ion-list class="ion-no-padding">
        <ion-reorder-group disabled="false" (ionItemReorder)="onMoveLeg($event)">
            @for (leg of vm.routeLegs; track $index) {
  <div>
                @if (leg.letter !== '?') {
  <ion-item class="ion-no-padding" [class.urgent]="leg.isUrgent">
                    <ion-grid>
                        <ion-row class="ion-align-items-center">
                            <!-- <ion-col size="2" ion-float-left> -->
                            <ion-col class="letterCol" size="2" size-md="1">
                                <span class="letter">{{leg.letter}}</span>
                            </ion-col>
                            <ion-col class="legDescCol" size="9" size-md="10" ion-float-right>
                                <span class="line1">To: {{leg.to.location.locationName}}</span><br />
                                <span class="line2">{{leg.to.location.address.fullAddress}}</span>
                            </ion-col>
                            <ion-col class="reorderCol" size="1" size-md="1" ion-float-right>
                                @if (vm.routeLegs.length > 2) {
  <ion-reorder data-test="reorderCol"></ion-reorder>
}
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-item>
}
            </div>
}
        </ion-reorder-group>
    </ion-list>

    <ion-list class="ion-no-padding">
        <ion-item class="ion-no-padding">
            <ion-grid>
                <ion-row class="ion-align-items-center">
                    <ion-col class="imageCol ion-float-left" size="2" size-md="1">
                        <img class="startEndImage" src="assets/images/endNS.png" />
                    </ion-col>
                    <ion-col class="legDescCol ion-float-right" size="10" size-md="11">
                        <span class="line1">End: {{vm.endingPoint.location.locationName}}</span><br />
                        <span class="line2">{{vm.endingPoint.location.address.fullAddress}}</span><br />
                    </ion-col>
                </ion-row>
                <!-- <ion-col class="letterCol" size="1" size-md="1" ion-float-right>
                    <span class="line1"> </span><br />
                </ion-col> -->
            </ion-grid>
        </ion-item>
    </ion-list>

    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button [disabled]=vb.disabled title="Next" (click)="onNextClick()" data-test="routeNext4">
            <ion-icon name="chevron-forward"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>